import React, { useEffect, useState } from 'react';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import TinySlider from 'tiny-slider-react';
import 'tiny-slider/dist/tiny-slider.css';

interface Review {
  nombre_usuario: string;
  ciudad: string;
  estrellas: number;
  reseña: string;
  perfil_id: string;
  tipo_perfil: string;
  razon: string;
}

const settings = {
  controls: false,
  mouseDrag: true,
  loop: true,
  rewind: true,
  autoplay: true,
  autoplayButtonOutput: false,
  autoplayTimeout: 3000,
  navPosition: 'bottom',
  nav: false,
  speed: 400,
  gutter: 0,
  responsive: {
    992: { items: 3 },
    767: { items: 2 },
    320: { items: 1 },
  },
};

export default function ClientOne({ perfilId }: { perfilId: string }) {
  const [reviews, setReviews] = useState<Review[]>([]);

  useEffect(() => {
    const fetchReviews = async () => {
      const q = query(
        collection(db, 'calificacion'),
        where('perfil_id', '==', perfilId),
        where('estatus', '==', 'aprobada')
      );
            const snap = await getDocs(q);
      const data = snap.docs.map(doc => doc.data() as Review);
      setReviews(data);
    };

    if (perfilId) fetchReviews();
  }, [perfilId]);

  if (reviews.length === 0) return null;

  const renderStars = (count: number) => {
    return Array.from({ length: 5 }, (_, i) => (
      <i
        key={i}
        className={`fa fa-star${i < count ? ' text-warning' : ' text-muted'}`}
        style={{ marginRight: '3px' }}
      ></i>
    ));
  };

  return (
    <section className="gray">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-6 col-lg-7 col-md-10 text-center">
            <div className="sec-heading center">
              <h2>Reseñas</h2>
              <p>Opiniones reales de quienes ya han trabajado con este profesional</p>
            </div>
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-12 col-md-12">
            <div className="smart-textimonials smart-center" id="smart-textimonials">
              <TinySlider settings={settings}>
                {reviews.map((item, index) => (
                  <div className="item" key={index}>
                    <div className="item-box">
                      <div className="smart-tes-author">
                        <div className="st-author-box">
                          <div className="st-author-thumb">
                            <div className="quotes"><i className="fa-solid fa-quote-left"></i></div>
                            <img src="/img/team-1.jpg" className="img-fluid" alt="" />
                          </div>
                        </div>
                      </div>

                      <div className="smart-tes-content">
                        <p>{item.reseña}</p>
                        <div>{renderStars(item.estrellas)}</div>
                      </div>

                      <div className="st-author-info">
                        <span className="st-author-subtitle">{item.ciudad}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </TinySlider>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
